import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEventType } from '@angular/common/http';
import { SERVICIOS_OPERACIONES } from 'config/services/operaciones';
import { API_VERSION } from 'config/api';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FileDeNotariaService {
    constructor(private http: HttpClient) {}
    listar(expedienteId: number) {
        return this.http.get<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.listar(expedienteId)}`);
    }
    listarLegal(expedienteId: number, id_caf) {
        return this.http.get<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.listarLegal(expedienteId, id_caf)}`);
    }
    subirDocumentos(data: FormData) {
        return this.http.post(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.subirDocumentos}`, data);
    }
    listarDocumentos(expedienteId: number, documentoId: number, seccionId: number, subseccionId: number) {
        return this.http.get<any>(
            `${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.listarDocumentos(expedienteId, documentoId, seccionId, subseccionId)}`
        );
    }
    historial(data: { id_expediente: number; id_documento: number; id_seccion: number; id_subseccion: number; pagina: number; filas: number }) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.historial}`, data);
    }
    enviarANotaria(
        expediented: number,
        data: {
            comentario: string;
            correo: string;
        }
    ) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.enviarANotaria(expediented)}`, data);
    }
    finalizar(
        expediented: number,
        data: {
            comentario: string;
        }
    ) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.finalizar(expediented)}`, data);
    }
    vigente(data: { id_expediente: number; id_seccion: number; id_subseccion: number; id_documento: number }) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.vigente}`, data);
    }
    descargar(
        expedienteId: number,
        data: Array<{
            iddocumento: number;
            idseccion: number;
            idsubseccion: number;
        }>
    ) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.descargar(expedienteId)}`, { documentos: data });
    }
    descargar_complementarios(
        data: any
    ) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.descargar_complementario()}`, { documentos: data });
    }
    check(data: { id_expediente: number; id_seccion: number; id_subseccion: number; id_documento: number; is_checked: boolean }) {
        return this.http.put<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.check}`, data);
    }
    configDoc(data) {
        return this.http.post<any>(`${API_VERSION.v1}${SERVICIOS_OPERACIONES.expediente.fileNoteria.config}`, data);
    }
    exportar(url: string, name: string) {
        return this.http
            .get<any>(`${url}`, {
                responseType: 'blob' as 'json',
                reportProgress: true,
                observe: 'events',
            })
            .pipe(
                map((blob: HttpResponse<Blob>) => {
                    if (blob.type == HttpEventType.Response) {
                        console.log(blob);
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob.body);
                        link.download = name;
                        link.click();
                    }
                    return blob;
                })
            );
    }
}
